import { useState } from "preact/hooks";
import { getBackendData } from "./backend/restClient";

export type Category = {
    id: string,
    title: string,
    slug: string,
    images: string[],
    productIds: string[],
};

export type Product = {
    id: string,
    categoryId?: string,
    title?: string,
    slug?: string,
    description?: string,
    images: string[],
    itemPrice?: number,
    dayPrice?: number,
    weekendPrice?: number,
    monthPrice?: number,
    isAddon: boolean,
    addonCategories: string[] | null,
    mandatoryAddons: string[] | null,
};

export type ShoppingBasketEntry = {
    product: Product,
    count: number,
}

export type ShoppingBasketState = {
    entries: ShoppingBasketEntry[],
    fromDate: Date | undefined,
    toDate: Date | undefined,
};

export type CheckoutDetails = {
    fullname: string,
    phone: string,
    email: string,
    address: string,
    startdate: Date | null,
    enddate: Date | null,
    startuse: Date | null,
    comment: string,
    fulfillmentmethod: "pickup" | "delivery",
    deliveryaddress: string,
    contactname: string,
    contactphone: string,
};

export const intitialCheckoutDetails = {} as any;

export const emptyShoppingBasket: ShoppingBasketState = {
    entries: [],
    fromDate: undefined,
    toDate: undefined,
};

export const data = {
    categories: [] as Category[],
    products: [] as Product[],
    ready: false
};

export function useData() {
    const [staticData, setStaticData] = useState({
        id: null as number | null
    });
    const [ready, setReady] = useState(data.ready);
    function check() {
        if (!data.ready) {
            setTimeout(() => {
                console.log("checking");
                check();
            }, 100);
        } else {
            setReady(data.ready);
        }
    }
    check();
    return data;
}

async function initData() {
    const result = await getBackendData();

    data.categories = result.data.categories.map(category => ({
        id: category.documentId,
        title: category.title,
        images: [], //  ["https://booking.flexudlejning.com/tenancy/assets/config/topbanner.jpg"],
        productIds: category.products?.map(n => n.documentId) ?? [],
        slug: category.slug
    }) as Category);

    data.products = result.data.products.map(product => ({
        id: product.documentId,
        title: product.title,
        slug: product.slug,
        description: product.description,
        itemPrice: product.itemPrice,
        dayPrice: product.dayPrice,
        weekendPrice: product.weekendPrice,
        monthPrice: product.monthPrice,
        images: product.images?.map(n => "https://rentomatic-cms.ontogenesis.com" + n.url) ?? [""],
        categoryId: data.categories.find(n => n.productIds?.indexOf(product.documentId) != -1)?.id,
        addonCategories: product.addonCategories?.map(n => n.documentId) ?? null,
        isAddon: product.isAddon,
        mandatoryAddons: product.mandatoryAddons?.map(n => n.documentId) ?? null,
    }) as Product);

    data.ready = true;
}

initData();
